{{#if isPipelined}}
virtual function void claim_id(logic [{{ interface.idMsbMaxParameter.name }}:0] id);
  {{ activeIdQVariable.identifier }}.push_back(id);
  {{ claimIdGrantVariable.identifier }}.put(1);
endfunction
{{/if}}
